import * as React from 'react'

interface SectionTitleProps {
    title: string
}

export default function SectionTitle ({ title }: SectionTitleProps) {
  return (
        <div className="section-title">
            <h2 className='h2-vt'>{title}</h2>
        </div>
  )
}
